import { memo } from "react";
import PropTypes from "prop-types";
import IconStarGrey from "app/features/booking/components/Trustpilot/IconStarGrey";
import IconStarGreenFull from "app/features/booking/components/Trustpilot/IconStarGreenFull";
import IconStarGreenHalf from "app/features/booking/components/Trustpilot/IconStarGreenHalf";
import IconStarLimeFull from "app/features/booking/components/Trustpilot/IconStarLimeFull";
import IconStarLimeHalf from "app/features/booking/components/Trustpilot/IconStarLimeHalf";
import IconStarRedFull from "app/features/booking/components/Trustpilot/IconStarRedFull";
import IconStarRedHalf from "app/features/booking/components/Trustpilot/IconStarRedHalf";
import "./TrustpilotStars.scss";

const TOTAL_STARS = 5;

const getStarIcons = rating => {
	if (rating >= 4.1) {
		return { Full: IconStarGreenFull, Half: IconStarGreenHalf };
	}
	if (rating >= 2.1) {
		return { Full: IconStarLimeFull, Half: IconStarLimeHalf };
	}
	return { Full: IconStarRedFull, Half: IconStarRedHalf };
};

const getDecimal = rating => {
	return Math.round((rating % 1) * 10) / 10;
};

const getFullStars = rating => {
	const decimal = getDecimal(rating);

	if (decimal >= 0.6 || decimal === 0) {
		return Math.ceil(rating);
	}
	return Math.floor(rating);
};

const hasHalfStar = rating => {
	const decimal = getDecimal(rating);
	return decimal >= 0.1 && decimal <= 0.5;
};

const TrustpilotStars = ({ rating }) => {
	const { Full, Half } = getStarIcons(rating);
	const fullCount = getFullStars(rating);
	const showHalf = hasHalfStar(rating);
	const greyCount = TOTAL_STARS - fullCount - (showHalf ? 1 : 0);

	return (
		<div className="trustpilot-stars" data-testid="trustpilot-stars">
			{Array.from({ length: fullCount }, (_, i) => (
				<Full
					key={`full-${i}`}
					className="trustpilot-stars__star"
					data-testid="trustpilot-star"
				/>
			))}
			{showHalf && (
				<Half key="half" className="trustpilot-stars__star" data-testid="trustpilot-star" />
			)}
			{Array.from({ length: greyCount }, (_, i) => (
				<IconStarGrey
					key={`grey-${i}`}
					className="trustpilot-stars__star"
					data-testid="trustpilot-star"
				/>
			))}
		</div>
	);
};

TrustpilotStars.propTypes = {
	rating: PropTypes.number,
};

export default memo(TrustpilotStars);
